import React, { useState, useEffect, useRef, useContext } from "react";

import { Button, Dialog, InputText, Toast } from "primereact";
import { confirmDialog } from 'primereact/confirmdialog';
import { InputTextarea } from "primereact/inputtextarea";
import { TabPanel, TabView } from "primereact/tabview";

import { useForm } from "../../../../../Base/Hooks/useForm";
import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../Base/Services/ToastService";
import Loader from "../../../../../Base/Components/Loader/Loader";
import Card from "../../../../../Base/Components/Card/Card";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";

import { addAreas, getAreas } from "../../../../../Base/API/Global/Areas/AreasRequests";
import { getSubCategoriasConCategorias } from "../../../../../Base/API/Global/SubCategorias/SubCategoriasRequests";
import { getClasificacionAreas } from "../../../../../API/Global/Areas/ClasificacionRequest";
import { getCuentasHijosQuick } from "../../../../../API/Finanzas/RegistroContable/RegistroContableRequest";
import { getManoObra } from "../../../../../API/Global/Vehiculos/VehiculosRequest";
import { eliminarCuentasAreas, getCuentasArea, guardarCuentasAreas } from "../../../../../API/Finanzas/CuentasAreas/cuentasAreasReques";


const AreaCrudModal = ({
  area,
  areaDialog,
  setAreaDialog,
  getArea,
  modo,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [areasList, setAreasList] = useState([{}]);
  const [clasificacionesList, setClasificacionesList] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [subCategoriasProductos, setSubCategoriasProductos] = useState([])
  const [subCategoriasServicios, setSubCategoriasServicios] = useState([])
  const [cuentas, setCuentas] = useState([])
  const [cuentasSintetico, setCuentasSintetico] = useState([])
  const [cuentasAlgodon, setCuentasAlgodon] = useState([]);
  const [manoObra, setManoObra] = useState([]);
  const [listadoDetalles, setListadoDetalles] = useState([]);
  const [listadoDetallesServicios, setListadoDetallesServicios] = useState([]);
  const [selectedDetalles, setSelectedDetalles] = useState([]);
  const [selectedDetallesServicios, setSelectedDetallesServicios] = useState([]);


  const initialValues = {
    IdArea: -1,
    Area: "",
    Description: "",
    Acronym: "",
    IdAreaGeneral: "",
    IdStatus: area ? area?.IdStatus : 5,
    ClaveAutomatizacionMateriales: "",
    IdEncargado: "",
    IdType: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const a = await getAreas();
    setAreasList(a);
    const clasTempo = await getClasificacionAreas();
    setClasificacionesList(clasTempo.filter(i => i?.IdEstado === 5));


    const subCategoriasTempo = await getSubCategoriasConCategorias()
    const excluidos = [11, 10];
    setSubCategoriasProductos(subCategoriasTempo.filter(e => !excluidos.includes(e?.IdCategoria)));
    setSubCategoriasServicios(subCategoriasTempo.filter(e => e.IdCategoria === 11))
    
    const tempoCuentasHijos = await getCuentasHijosQuick()
    let algodon = []
    let sintetico = []
    let cuentas = []

    tempoCuentasHijos.forEach(c => {
      if (c.IdSubCategoria === 7) {
        algodon.push({
          IdCuentaAlgodon: c.IdAccount,
          CuentaAlgodon: c.NombreCuenta,
          Account: c.Account,
          IdCuentaHermana: c.IdCuentaHermana,
          CuentaHermana: c.CuentaHermana
        });
      }
      if (c.IdSubCategoria === 6) {
        sintetico.push({
          IdCuentaSintetico: c.IdAccount,
          CuentaSintetico: c.NombreCuenta,
          Account: c.Account,
          IdCuentaHermana: c.IdCuentaHermana,
          CuentaHermana: c.CuentaHermana
        })
      }
      cuentas.push({
        IdCuentaFinanzas: c.IdAccount,
        CuentaFinanzas: c.NombreCuenta,
        Account: c.Account,
        IdCuentaHermana: c.IdCuentaHermana,
        CuentaHermana: c.CuentaHermana
      })
    });

    setCuentas(cuentas)
    setCuentasAlgodon(algodon)
    setCuentasSintetico(sintetico)

    const manoTempo = await getManoObra()
    setManoObra(manoTempo)


    if (area) {
      setValues({
        ...area,
        IdStatus: 5,
        Clasificacion: clasTempo.find((c) => area?.IdAreaGeneral === c?.IdClasificacion),
      });

      const detTempo = await getCuentasArea(area?.IdArea)
      setListadoDetalles(detTempo.filter(i => i?.IdTipo === 1))
      setListadoDetallesServicios(detTempo.filter(i => i?.IdTipo === 2))

    } else {
      setValues({
        ...initialValues,
      });
    }
    setLoading(false);
  };

  const onHide = () => {
    setAreaDialog(false);
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Area) {
      error.Area = true;
      error.error = true;
    }
    if (!/^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ\s.\-_]*$/.test(values.Description)) {
      error.Description = true;
      error.error = true;
    }
    if (!values.Clasificacion || !values.Clasificacion.IdClasificacion) {
      error.IdClasificacion = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const VerificarInformacion = () => {
    let errores = [];

    // 1. Subcategoría vacía o nula
    let sinSub = listadoDetalles.some((l) => l.IdSubCategoria === 0 || l.IdSubCategoria === null);
    errores.push(sinSub);

    // 2. Duplicados por combinación IdSubCategoria + IdManoObra
    let combinaciones = new Set();
    let duplicados = listadoDetalles.some((elem) => {
      const clave = `${elem.IdSubCategoria}-${elem.IdManoObra}`;
      if (combinaciones.has(clave)) {
        return true; // Duplicado encontrado
      }
      combinaciones.add(clave);
      return false;
    });
    errores.push(duplicados);

    // 3. Si es doble cuenta, debe tener ambas cuentas
    let sinCuentaDoble = listadoDetalles.some(
      (l) =>
        l.IsDobleCuenta &&
        (!l.IdCuentaAlgodon || l.IdCuentaAlgodon === 0 || !l.IdCuentaSintetico || l.IdCuentaSintetico === 0)
    );
    errores.push(sinCuentaDoble);

    // 4. Si NO es doble cuenta, debe tener cuenta de finanzas
    let sinCuenta = listadoDetalles.some(
      (l) =>
        !l.IsDobleCuenta &&
        (!l.IdCuentaFinanzas || l.IdCuentaFinanzas === 0)
    );
    errores.push(sinCuenta);
    return errores.some((e) => e === true); // Si hay algún error, retorna true
  };

  const guardarInformacion = async () => {
    const e = verificarInfo();
    if (e?.error) {
      toastShow(toast, "warn", "Requerido", "Completar los campos requeridos");
    }

    if (!e.error) {
      const existingType = areasList.find((cur) => cur.Area === values?.Area);
      if ( existingType && (modo === "Crear" || existingType.IdArea !== values.IdArea)) {
        toastShow(toast, "error", "Error", "Ya existe una Area con ese nombre");
      } else {
        let detalles = activeIndex === 0 ? listadoDetalles : listadoDetallesServicios
        if(detalles?.length > 0){
          const veri = VerificarInformacion()
          if (veri || detalles.length === 0) {
            toastShow(toast, 'error', 'Error', 'Todas las filas deben contener información');
            return
          } else {

            let message = <div>¿Está seguro que desea guardar la información? </div>
            confirmDialog({
              message: message,
              header: 'Confirmación',
              icon: 'pi pi-exclamation-triangle',
              accept: async () => {
                setLoading(true);
                const a = {
                  IdArea: values?.IdArea,
                  Area: values?.Area,
                  Description: values?.Description,
                  Acronym: values?.Acronym,
                  IdAreaGeneral: values?.IdAreaGeneral ? values?.IdAreaGeneral : values?.Clasificacion?.IdClasificacion,
                  ClaveAutomatizacionMateriales: values?.ClaveAutomatizacionMateriales,
                  IdEncargado: values?.IdEncargado,
                  IdUserCreate: userAuth?.IdUser,
                  IdUserEdit: userAuth?.IdUser,
                };
                const result = await guardarCuentasAreas(detalles.filter((l) => l.edit === true))
                const resultado = await addAreas(a);
                const dialogTitle = "Registros guardados exitosamente." 
                toastShow(toast, "success", "Datos Agregados", dialogTitle);
                setTimeout(() => {
                  setLoading(false);
                  getArea();
                }, 1000);
              }, 
              reject: () => {}
            })
          }
          return
        }
        setLoading(true);
        const a = {
          IdArea: values?.IdArea,
          Area: values?.Area,
          Description: values?.Description,
          Acronym: values?.Acronym,
          IdAreaGeneral: values?.IdAreaGeneral ? values?.IdAreaGeneral : values?.Clasificacion?.IdClasificacion,
          ClaveAutomatizacionMateriales: values?.ClaveAutomatizacionMateriales,
          IdEncargado: values?.IdEncargado,
          IdUserCreate: userAuth?.IdUser,
        };

        const dialogTitle =  modo === "Crear"    ? "Registro Guardado exitosamente."    : "Registro Actualizado exitosamente.";
        const resultado = await addAreas(a);
        toastShow(toast, "success", "Datos Agregados", dialogTitle);
        setTimeout(() => {
          setLoading(false);
          onHide();
          getValoresIniciales()
          getArea();
        }, 1000);
      }
    }
  };

  const NuevaFila = () => {

    const e = verificarInfo();
    if (e?.error) {
      toastShow(toast, "warn", "Requerido", "Completar los campos requeridos");
      return
    }

    let newRow = [...listadoDetalles]
    let IdAletorio = (Math.floor(Math.random() * 100) + 1) * (-1)
    let existeId = listadoDetalles.some((l) => l.Id === IdAletorio)

    let dataNueva = {
      Id: existeId ? IdAletorio * 23 : IdAletorio,
      IdArea: values?.IdArea,
      IdManoObra: null,
      IdSubCategoria: null,
      NombreSubCategoria: '',
      IdCuentaFinanzas: null,
      CuentaFinanzas: '',
      IsDobleCuenta: 0,
      IdCuentaSintetico: null,
      CuentaSintetico: '',
      IdCuentaAlgodon: null,
      CuentaAlgodon: null,
      IdUserEdit: userAuth?.IdUser,
      IdEstado: 3,
      IsDivideCuenta: 0,
      IdClasificacion: values?.Clasificacion.IdClasificacion || values?.IdClasificacion
    }
    let nuevoArreglo = newRow.concat(dataNueva)
    setListadoDetalles(nuevoArreglo)
  }

  const NuevaFilaServicios = () => {

    const e = verificarInfo();
    if (e?.error) {
      toastShow(toast, "warn", "Requerido", "Completar los campos requeridos");
      return
    }

    let newRow = [...listadoDetallesServicios]
    let IdAletorio = (Math.floor(Math.random() * 100) + 1) * (-1)
    let existeId = listadoDetallesServicios.some((l) => l.Id === IdAletorio)

    let dataNueva = {
      Id: existeId ? IdAletorio * 23 : IdAletorio,
      IdArea: values?.IdArea,
      IdManoObra: null,
      IdSubCategoria: null,
      NombreSubCategoria: '',
      IdCuentaFinanzas: null,
      CuentaFinanzas: '',
      IsDobleCuenta: 0,
      IdCuentaSintetico: null,
      CuentaSintetico: '',
      IdCuentaAlgodon: null,
      CuentaAlgodon: null,
      IdUserEdit: userAuth?.IdUser,
      IdEstado: 3,
      IsDivideCuenta: 0,
      IdClasificacion: values?.Clasificacion.IdClasificacion || values?.IdClasificacion,
      IdTipo: 2,
    }
    let nuevoArreglo = newRow.concat(dataNueva)
    setListadoDetallesServicios(nuevoArreglo)
  }

  const CuentaDoble = (checked, rowData) => {
    let detalle = { ...rowData }
    detalle.IsDobleCuenta = !checked


    detalle.IdCuentaFinanzas = !checked ? null : detalle.IdCuentaFinanzas
    detalle.CuentaFinanzas = !checked ? null : detalle.CuentaFinanzas


    detalle.IdCuentaAlgodon = checked ? null : detalle.IdCuentaAlgodon
    detalle.CuentaAlgodon = checked ? null : detalle.CuentaAlgodon

    detalle.IdCuentaSintetico = checked ? null : detalle.IdCuentaSintetico
    detalle.CuentaSintetico = checked ? null : detalle.CuentaSintetico
    detalle.IdUserEdit = userAuth?.IdUser
    detalle.IdTipo = activeIndex === 0 ? 1 : 2


    if(activeIndex === 0){
      let tempo = [...listadoDetalles]
      const index = tempo.findIndex(detail => detail.Id === detalle.Id)
      tempo[index] = detalle
  
      setLoading(true)
      setListadoDetalles(tempo)
      setLoading(false)
    }else if (activeIndex ===  1){
      let tempo = [...listadoDetallesServicios]
      const index = tempo.findIndex(detail => detail.Id === detalle.Id)
      tempo[index] = detalle

      setLoading(true)
      setListadoDetallesServicios(tempo)
      setLoading(false)
    }

  }

  const RemoverFila = () => {
    if (selectedDetalles?.length === 0) {
      toastShow(toast, 'warn', 'Error', 'Debe seleccionar la fila que desea remover');
    } else {
      let message = <div>¿Está seguro que desea remover la fila? </div>

      confirmDialog({
        message: message,
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
          let datos = selectedDetalles
          let enviar = datos.filter((d) => d.Id > 0)
          let Ids = enviar.map(i => i?.Id)
          let listadoActual = listadoDetalles.filter(i => !selectedDetalles.some(e => e.Id === i.Id))
          if (enviar?.length > 0) {
            const result = await eliminarCuentasAreas(Ids.join(','))
            toastShow(toast, 'success', 'Eliminado', 'Registro eliminado correcatmente');
          }
          setListadoDetalles(listadoActual)
          setSelectedDetalles([])
        }, 
        reject: () => {}
      })
    }
  }

  const RemoverFilaServicios = () => {
    if (selectedDetallesServicios?.length === 0) {
      toastShow(toast, 'warn', 'Error', 'Debe seleccionar la fila que desea remover');
    } else {
      let message = <div>¿Está seguro que desea remover la fila? </div>

      confirmDialog({
        message: message,
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
          let datos = selectedDetallesServicios
          let enviar = datos.filter((d) => d.Id > 0)
          let Ids = enviar.map(i => i?.Id)
          let listadoActual = listadoDetallesServicios.filter(i => !selectedDetallesServicios.some(e => e.Id === i.Id))
          if (enviar?.length > 0) {
            const result = await eliminarCuentasAreas(Ids.join(','))
            toastShow(toast, 'success', 'Eliminado', 'Registro eliminado correcatmente');

          }
          setListadoDetallesServicios(listadoActual)
          setSelectedDetallesServicios([])
        }, 
        reject: () => {}
      })
    }
  }

  const columnsMateriales = [
    {
      header: 'Id',
      handerEn: '',
      field: 'Id',
      hidden: userAuth?.IdRol === 1,
      className: 'Xsmall',
    },
    {
      field: "NombreCompuesto",
      header: "Sub Categoria",
      className: "XXlarge",
      filter: true,
      editable: true,
      value: "IdSubCategoria",
      label: "NombreCompuesto",
      items: subCategoriasProductos,
      Format: "AutoComplete",
      Sumary: "count",
      onChange: ({ state, data, value, label, api, items }) => {
        let dataRow = { ...data }
        if (state?.IdSubCategoria) {
          let li = listadoDetalles.some((l) => l.Id !== dataRow.Id && (l.IdSubCategoria === state?.IdSubCategoria) && l.IdManoObra === dataRow?.IdManoObra)

          if (li) {
            dataRow.IdSubCategoria = null
            dataRow.NombreCompuesto = null
            dataRow.IdUserEdit = userAuth?.IdUser
            dataRow.edit = true
            toastShow(toast, 'error', 'Error', 'Esta SubCategoria ya fue seleccionada')
          } else {
            dataRow.IdSubCategoria = state?.IdSubCategoria
            dataRow.NombreCompuesto = state?.SubCategoria
            dataRow.IdUserEdit = userAuth?.IdUser
            dataRow.edit = true
            dataRow.IdTipo = 1
          }
          let tempo = [...listadoDetalles]
          const index = tempo.findIndex(detail => detail.Id === dataRow.Id)
          tempo[index] = dataRow
          setListadoDetalles(tempo)
        }
      }
    },

    {
      field: "Abreviacion",
      header: "Mano Obra",
      headerEn: "Mano Obra",
      className: "small",
      editable: true,
      Format: "AutoComplete",
      value: "IdManoObra",
      label: "Abreviacion",
      items: manoObra,
      onChange: ({ state, data, value, label, api, items }) => {
        let dataRow = { ...data }
        if (state) {
          let li = listadoDetalles.some((l) => l.Id !== data.Id && (l.IdSubCategoria === data?.IdSubCategoria) && l.IdManoObra === state?.IdManoObra)
          if (li) {
            dataRow.IdManoObra = null
            dataRow.Abreviacion = null
            dataRow.IdUserEdit = userAuth?.IdUser
            dataRow.UserName = userAuth?.UserName
            dataRow.edit = true
            dataRow.IdTipo = 1
            toastShow(toast, 'error', 'Error', 'Ya existe una subCategoria con esa mano de obra')
          } else {
            dataRow.IdManoObra = state?.IdManoObra
            dataRow.Abreviacion = state?.Abreviacion
            dataRow.IdUserEdit = userAuth?.IdUser
            dataRow.UserName = userAuth.UserName
            dataRow.edit = true
            dataRow.IdTipo = 1
          }

          let tempo = [...listadoDetalles]
          const index = tempo.findIndex(detail => detail.Id === dataRow.Id)
          tempo[index] = dataRow
          setListadoDetalles(tempo)
        }
      },
    },
    {
      field: "CuentaFinanzas",
      header: "Cuenta Finanzas",
      width: 750,
      filter: true,
      editable: ({ data }) => {
        if (!data.IsDobleCuenta) return true;
        return false;
      },
      value: "IdCuentaFinanzas",
      label: "CuentaFinanzas",
      items: cuentas,
      Format: "AutoComplete",
      onChange: ({ state, data, value, label, api, items }) => {
        if (state) {
          data.IdCuentaFinanzas = state?.IdCuentaFinanzas
          data.CuentaFinanzas = state?.CuentaFinanzas
          data.IdUserEdit = userAuth?.IdUser
          data.edit = true
          data.IdTipo = 1
        }
      }
    },
    {
      field: "IsDobleCuenta",
      header: "Is Doble Cuenta",
      className: "Xsmall",
      filter: true,
      Format: "Checkbox",
      onChange: (e, rowData) => { CuentaDoble(rowData.value, rowData.data) },
    },
    {
      field: "CuentaSintetico",
      header: "Cuenta Sintetico",
      width: 750,
      filter: true,
      editable: ({ data }) => {
        if (data.IsDobleCuenta) return true;
        return false;
      },
      value: "IdCuentaSintetico",
      label: "CuentaSintetico",
      items: cuentasSintetico,
      Format: "AutoComplete",
      onChange: ({ state, data, value, label, api, items, oldValue}) => {
        let tempo = [...listadoDetalles]
        if (state?.IdCuentaSintetico !== oldValue?.IdCuentaSintetico) {
          if (data.Id) {
            data.IdCuentaSintetico = state?.IdCuentaSintetico
            data.CuentaSintetico = state?.CuentaSintetico
            data.IdCuentaAlgodon = state?.IdCuentaHermana ? state?.IdCuentaHermana : data?.IdCuentaAlgodon
            data.CuentaAlgodon = state?.CuentaHermana ? state?.CuentaHermana : data?.CuentaAlgodon
            data.IdUserEdit = userAuth?.IdUser
            data.UserName = userAuth?.UserName
            data.edit = true
            data.IdTipo = 1


            const index = tempo.findIndex((detail) => detail.Id === data.Id)
            tempo[index] = data
          }
        } else {
          return
        }
        setSelectedDetalles([])
        setListadoDetalles(tempo)
      }
    },
    {
      field: "CuentaAlgodon",
      header: "Cuenta Algodon",
      width: 750,
      filter: true,
      editable: ({ data }) => {
        if (data.IsDobleCuenta) return true;
        return false;
      },
      value: "IdCuentaAlgodon",
      label: "CuentaAlgodon",
      items: cuentasAlgodon,
      Format: "AutoComplete",
      onChange: ({ state, data, value, label, api, items, oldValue}) => {
        let tempo = [...listadoDetalles]
        if (state?.IdCuentaAlgodon !== oldValue?.IdCuentaAlgodon) {
          if (data.Id) {
            data.IdCuentaAlgodon = state?.IdCuentaAlgodon
            data.CuentaAlgodon = state?.CuentaAlgodon
            data.IdCuentaSintetico = state?.IdCuentaHermana ? state?.IdCuentaHermana : data?.IdCuentaSintetico
            data.CuentaSintetico = state?.CuentaHermana ? state?.CuentaHermana : data?.CuentaSintetico
            data.IdUserEdit = userAuth?.IdUser
            data.UserName = userAuth?.UserName
            data.edit = true
            data.IdTipo = 1


            const index = tempo.findIndex((detail) => detail.Id === data.Id)
            tempo[index] = data
          }
        } else {
          return
        }
        setSelectedDetalles([])
        setListadoDetalles(tempo)
      }
    },
    {
      field: "UserName",
      header: "Usuario",
      className: "medium",
    },
  ];

  const tableMateriales = {
    Columns: columnsMateriales,
    Data: listadoDetalles,
    setSelected: setSelectedDetalles,
    selected: selectedDetalles,
  }

  const columnsServicios = [
    {
      header: 'Id',
      handerEn: '',
      field: 'Id',
      hidden: userAuth?.IdRol === 1,
      className: 'Xsmall',
    },
    {
      field: "NombreCompuesto",
      header: "Sub Categoria",
      className: "XXlarge",
      filter: true,
      editable: true,
      value: "IdSubCategoria",
      label: "NombreCompuesto",
      items: subCategoriasServicios,
      Format: "AutoComplete",
      Sumary: "count",
      onChange: ({ state, data, value, label, api, items }) => {
        let dataRow = { ...data }
        if (state?.IdSubCategoria) {
          let li = listadoDetallesServicios.some((l) => l.Id !== dataRow.Id && (l.IdSubCategoria === state?.IdSubCategoria) && l.IdManoObra === dataRow?.IdManoObra)

          if (li) {
            dataRow.IdSubCategoria = null
            dataRow.NombreCompuesto = null
            dataRow.IdUserEdit = userAuth?.IdUser
            dataRow.edit = true
            toastShow(toast, 'error', 'Error', 'Esta SubCategoria ya fue seleccionada')
          } else {
            dataRow.IdSubCategoria = state?.IdSubCategoria
            dataRow.NombreCompuesto = state?.SubCategoria
            dataRow.IdUserEdit = userAuth?.IdUser
            dataRow.edit = true
            dataRow.IdTipo = 2
          }
          let tempo = [...listadoDetallesServicios]
          const index = tempo.findIndex(detail => detail.Id === dataRow.Id)
          tempo[index] = dataRow
          setListadoDetallesServicios(tempo)
        }
      }
    },

    {
      field: "Abreviacion",
      header: "Mano Obra",
      headerEn: "Mano Obra",
      className: "small",
      editable: true,
      Format: "AutoComplete",
      value: "IdManoObra",
      label: "Abreviacion",
      items: manoObra,
      onChange: ({ state, data, value, label, api, items }) => {
        let dataRow = { ...data }
        if (state) {
          let li = listadoDetallesServicios.some((l) => l.Id !== data.Id && (l.IdSubCategoria === data?.IdSubCategoria) && l.IdManoObra === state?.IdManoObra)
          if (li) {
            dataRow.IdManoObra = null
            dataRow.Abreviacion = null
            dataRow.IdUserEdit = userAuth?.IdUser
            dataRow.UserName = userAuth?.UserName
            dataRow.edit = true
            toastShow(toast, 'error', 'Error', 'Ya existe una subCategoria con esa mano de obra')
          } else {
            dataRow.IdManoObra = state?.IdManoObra
            dataRow.Abreviacion = state?.Abreviacion
            dataRow.IdUserEdit = userAuth?.IdUser
            dataRow.UserName = userAuth.UserName
            dataRow.edit = true
          }

          let tempo = [...listadoDetallesServicios]
          const index = tempo.findIndex(detail => detail.Id === dataRow.Id)
          tempo[index] = dataRow
          setListadoDetallesServicios(tempo)
        }
      },
    },
    {
      field: "CuentaFinanzas",
      header: "Cuenta Finanzas",
      width: 750,
      filter: true,
      editable: ({ data }) => {
        if (!data.IsDobleCuenta) return true;
        return false;
      },
      value: "IdCuentaFinanzas",
      label: "CuentaFinanzas",
      items: cuentas,
      Format: "AutoComplete",
      onChange: ({ state, data, value, label, api, items }) => {
        if (state) {
          data.IdCuentaFinanzas = state?.IdCuentaFinanzas
          data.CuentaFinanzas = state?.CuentaFinanzas
          data.IdUserEdit = userAuth?.IdUser
          data.edit = true
        }
      }
    },
    {
      field: "IsDobleCuenta",
      header: "Is Doble Cuenta",
      className: "Xsmall",
      filter: true,
      Format: "Checkbox",
      onChange: (e, rowData) => { CuentaDoble(rowData.value, rowData.data) },
    },
    {
      field: "CuentaSintetico",
      header: "Cuenta Sintetico",
      width: 750,
      filter: true,
      editable: ({ data }) => {
        if (data.IsDobleCuenta) return true;
        return false;
      },
      value: "IdCuentaSintetico",
      label: "CuentaSintetico",
      items: cuentasSintetico,
      Format: "AutoComplete",
      onChange: ({ state, data, value, label, api, items, oldValue}) => {
        let tempo = [...listadoDetallesServicios]
        if (state?.IdCuentaSintetico !== oldValue?.IdCuentaSintetico) {
          if (data.Id) {
            data.IdCuentaSintetico = state?.IdCuentaSintetico
            data.CuentaSintetico = state?.CuentaSintetico
            data.IdCuentaAlgodon = state?.IdCuentaHermana ? state?.IdCuentaHermana : data?.IdCuentaAlgodon
            data.CuentaAlgodon = state?.CuentaHermana ? state?.CuentaHermana : data?.CuentaAlgodon
            data.IdUserEdit = userAuth?.IdUser
            data.UserName = userAuth?.UserName
            data.edit = true

            const index = tempo.findIndex((detail) => detail.Id === data.Id)
            tempo[index] = data
          }
        } else {
          return
        }
        setSelectedDetallesServicios([])
        setListadoDetallesServicios(tempo)
      }
    },
    {
      field: "CuentaAlgodon",
      header: "Cuenta Algodon",
      width: 750,
      filter: true,
      editable: ({ data }) => {
        if (data.IsDobleCuenta) return true;
        return false;
      },
      value: "IdCuentaAlgodon",
      label: "CuentaAlgodon",
      items: cuentasAlgodon,
      Format: "AutoComplete",
      onChange: ({ state, data, value, label, api, items, oldValue}) => {
        let tempo = [...listadoDetallesServicios]
        if (state?.IdCuentaAlgodon !== oldValue?.IdCuentaAlgodon) {
          if (data.Id) {
            data.IdCuentaAlgodon = state?.IdCuentaAlgodon
            data.CuentaAlgodon = state?.CuentaAlgodon
            data.IdCuentaSintetico = state?.IdCuentaHermana ? state?.IdCuentaHermana : data?.IdCuentaSintetico
            data.CuentaSintetico = state?.CuentaHermana ? state?.CuentaHermana : data?.CuentaSintetico
            data.IdUserEdit = userAuth?.IdUser
            data.UserName = userAuth?.UserName
            data.edit = true

            const index = tempo.findIndex((detail) => detail.Id === data.Id)
            tempo[index] = data
          }
        } else {
          return
        }
        setSelectedDetalles([])
        setListadoDetallesServicios(tempo)
      }
    },
    {
      field: "UserName",
      header: "Usuario",
      className: "medium",
    },
  ];

  const tableServicios = {
    Columns: columnsServicios,
    Data: listadoDetallesServicios,
    setSelected: setSelectedDetallesServicios,
    selected: selectedDetallesServicios,
  }

  useEffect(() => {
    if (areaDialog) {
      getValoresIniciales();
    }
  }, [areaDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Area" : "Modificar Area";

  useEffect(() => {
    setSelectedDetalles([])
    setSelectedDetallesServicios([])
    getValoresIniciales()
  }, [activeIndex]);

  return (
    <div className="form-demo px-3 mb-2 mt-2">
      <div className="d-flex flex-column justify-content-center">
        <Dialog
          visible={areaDialog}
          modal
          className="modal__usuarios"
          onHide={onHide}
          maximized
          maximizable
        >
          <div id="areasDialog">
            <Loader loading={loading} querySelector={"#areasDialog"} />
            <Toast ref={toast} />
            <Card
              titulo={
                <div>
                  <h3>{dialogTitle}</h3>
                </div>
              }
              contenido={
                <div>
                  <div className="d-flex flex-wrap align-items-start gap-2 my-2 mt-4">
                    <div className="field col-2">
                      <span className="p-float-label">
                        <InputText
                          name="Area"
                          value={values.Area}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.Area ? "p-invalid" : ""}
                        />
                        <label htmlFor="Area">Nombre</label>
                      </span>
                    </div>

                    <div className="field col-4">
                      <span className="p-float-label">
                        <InputTextarea
                          name="Description"
                          value={values?.Description}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.Description ? "p-invalid" : ""}
                          rows={1}
                        />
                        <label htmlFor="Description">Descripción</label>
                        {error.Description && (
                          <small className="p-error">
                            La Descripción solo puede contener letras, números,
                            espacios y los caracteres '.', '_', '-'.
                          </small>
                        )}
                      </span>
                    </div>

                    <AutoCompleteDropdown
                      name={"Clasificacion"}
                      value={values?.Clasificacion}
                      items={clasificacionesList}
                      enable={activeIndex === 0 ? listadoDetalles?.length <= 0 : listadoDetallesServicios?.length <= 0}
                      field={"Clasificacion"}
                      label={"Clasificación"}
                      handleInputChange={handleInputChange}
                      className={error.IdClasificacion ? "p-invalid" : ""}
                    />

                    {/* BOTONES */}
                    <div className="d-flex flex-wrap gap-2 mx-4">
                      <Button
                        icon="pi pi-plus"
                        type="button"
                        disabled={values?.IdArea <= 0}
                        tooltip="Agregar Items"
                        tooltipOptions={{ position: "top"}}
                        onClick={(e) => {
                          if(activeIndex === 0){
                            NuevaFila()
                          }else if (activeIndex === 1){
                            NuevaFilaServicios()
                          }
                        }}
                        tabIndex={8}
                      />

                      <Button
                        icon="pi pi-times"
                        disabled={values?.IdArea <= 0 || activeIndex === 0 ? selectedDetalles?.length <=0 : selectedDetallesServicios?.length <=0}
                        type="button"
                        severity="danger"
                        tooltip="Eliminar Items"
                        tooltipOptions={{ position: "top"}}
                        onClick={(e) => {
                          if(activeIndex === 0){
                            RemoverFila()
                          }else if (activeIndex === 1){
                            RemoverFilaServicios()
                          }
                        }}
                      />

                      <Button
                        icon="pi pi-save"
                        type="button"
                        tooltip="Guardar"
                        tooltipOptions={{ position: "top"}}
                        onClick={(e) => { guardarInformacion()}}
                        tabIndex={8}
                      />

                      <Button
                        icon="pi pi-sync"
                        type="button"
                        tooltip="Recargar"
                        tooltipOptions={{ position: "top" }}
                        onClick={(e) => {
                          getValoresIniciales();
                        }}
                        tabIndex={8}
                      />
                    </div>
                  </div>
                </div>
              }
            />

            <Card
              contenido={
                <div className="bg-red">
                  <TabView
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                  >
                    <TabPanel header="Bodega de materiales">
                      <div className="pt-0" style={{ height: "70vh" }}>
                        <AgGrid table={tableMateriales} />
                      </div>
                    </TabPanel>

                    <TabPanel header="Servicios">
                      <div style={{ height: "70vh" }}>
                        <AgGrid table={tableServicios} />
                      </div>
                    </TabPanel>
                  </TabView>
                </div>
              }
            />
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default AreaCrudModal;
